<div class="filter">
  <div class="main-filters__button">
    @if(isMapEmpty()){
    <sl-button
      iconName="filter_list"
      variant="tertiary"
      label="Filter"
      [id]="'filter-button'"
      size="small"
      type="icon-left"
      (keyDownEvent)="onKeyDownMainButton($event)"
      (clickEvent)="handleOpenActionsMenu(!isOpen)"
      (focusout)="onFocusout($event)"
    ></sl-button>
    }@else {
    <sl-button
      iconSvg="assets/images/Filter-on.svg"
      variant="tertiary"
      label="Filter"
      [id]="'filter-button'"
      size="small"
      type="icon-left"
      (keyDownEvent)="onKeyDownMainButton($event)"
      (clickEvent)="handleOpenActionsMenu(!isOpen)"
      (focusout)="onFocusout($event)"
    ></sl-button>
    }
  </div>
  @if(isOpen){
  <div class="filter__menu" #filterMenu (focusout)="onFocusout($event)">
    <div class="filter__items">
      @if(!openedElementKey){
      <sl-search
        [id]="'sl-filter-search'"
        (searchTextChangeEvent)="onChangeGlobalSearch($event)"
        (click)="onClickSearch()"
        (keydown)="onKeyDownMenu($event)"
      ></sl-search>
      @for(item of Object.keys(filterConfig); track item; let i = $index){

      <div class="filter__container" #itemsContainer>
        @if(filterConfig[item].isCollapsable){
        <button
          (click)="onClickForwardSection(item)"
          class="section__button"
          [id]="'sl-filter-forward-button-' + item"
          (keydown)="onKeyDownMenu($event)"
          (focusout)="onFocusoutSectionButton($event)"
        >
          <div class="filter__title filter__title--forward">
            <div
              [ngStyle]="{
                display: 'flex',
                'flex-direction': 'row',
                gap: '8px'
              }"
            >
              <sl-typography variant="body-10" [text]="item"></sl-typography>
              @if(countSelectedElements(item)){
              <sl-tag
                [size]="tagSize.SMALL"
                [label]="countSelectedElements(item).toString()"
                [color]="tagcolorVariants.PURPLE"
              ></sl-tag>
              }
            </div>
            <span class="material-symbols-outlined">keyboard_arrow_right</span>
          </div>
        </button>
        } @else{
        <div class="filter__title">
          <sl-typography variant="body-10" [text]="item"></sl-typography>
          @if(countSelectedElements(item)){
          <sl-tag
            [size]="tagSize.SMALL"
            [label]="countSelectedElements(item).toString()"
            [color]="tagcolorVariants.PURPLE"
          ></sl-tag>
          }
        </div>

        <div class="filter__checkboxes">
          <sl-checkbox-menu-item
            [id]="'sl-filter-checkbox-' + item"
            [items]="getCheckboxItems(item)"
            (keydown)="onKeyDownMenu($event)"
            (selectionChange)="onSelectCheckbox(item, $event)"
            (clickedElementEvent)="onClickCheckbox(item, $event)"
          ></sl-checkbox-menu-item>
        </div>
        }
      </div>
      } }@else if(openedElementKey){
      <button
        (click)="onClickBackSection()"
        class="section__button"
        [id]="'sl-filter-back-button-' + openedElementKey"
        (keydown)="onKeyDownMenu($event)"
        (focusout)="onFocusoutSectionButton($event)"
      >
        <div class="filter__title">
          <span class="material-symbols-outlined back__icon"
            >keyboard_arrow_left</span
          >
          <sl-typography
            variant="body-10"
            [text]="openedElementKey"
          ></sl-typography>
          @if(countSelectedElements(openedElementKey)){
          <sl-tag
            [size]="tagSize.SMALL"
            [label]="countSelectedElements(openedElementKey).toString()"
            [color]="tagcolorVariants.PURPLE"
          ></sl-tag>
          }
        </div>
      </button>
      <div class="filter__content">
        <sl-search
          [id]="'sl-filter-search'"
          (keydown)="onKeyDownMenu($event)"
          (searchTextChangeEvent)="onChangeItemSearch($event, openedElementKey)"
        ></sl-search>
        <div class="filter__checkboxes">
          <sl-checkbox-menu-item
            [id]="'sl-filter-checkbox-' + openedElementKey"
            [items]="getCheckboxItems(openedElementKey)"
            (selectionChange)="onSelectCheckbox(openedElementKey, $event)"
            (keydown)="onKeyDownMenu($event)"
            (clickedElementEvent)="onClickCheckbox(openedElementKey, $event)"
            (focusout)="onFocusout($event)"
          ></sl-checkbox-menu-item>
        </div>
      </div>
      }
    </div>

    <div
      class="filter__buttons"
      [ngStyle]="{
        'justify-content': showResetButton ? 'space-between' : 'flex-end'
      }"
    >
      @if(showResetButton){
      <sl-button
        [id]="'sl-filter-clear-all-button'"
        label="Reset filters"
        size="small"
        variant="tertiary"
        (clickEvent)="clearAllFilters()"
        (keyDownEvent)="onKeyDownMenu($event)"
        (focusout)="onFocusoutSectionButton($event)"
      />
      }

      <div class="filter__buttons--right">
        <sl-button
          [id]="'sl-filter-cancel-button'"
          label="Cancel"
          size="small"
          variant="tertiary"
          (keyDownEvent)="onKeyDownMenu($event)"
          (clickEvent)="handleOpenActionsMenu(false)"
        />
        <sl-button
          [id]="'sl-filter-apply-button'"
          label="Apply filter"
          variant="primary"
          size="small"
          (keyDownEvent)="onKeyDownMenu($event)"
          (clickEvent)="applyFilters()"
        />
      </div>
    </div>
  </div>
  }
</div>
